export default __webpack_public_path__ + "static/media/rotate_right-24px.1d10b206.svg";